import apiClient from '@/utils/request'
import { nestedQueryFormatter } from '@/utils/query'
import {
  IRequestPayload,
  IGeneralResponse,
  IItem,
  IAttributes
} from '@/api/types'

export interface IFaqAttributes extends IAttributes {
  title: string
  content: string
  page: string[]
}

export interface IFaq {
  id: string
  type: 'faq'
  attributes: IFaqAttributes
}

export interface IFaqResponse {
  id: string
  hits: number
  events: number
}

export interface IFaqPayload extends IRequestPayload {
  id: string
  hits: boolean
  events: boolean
  page: string
}

interface IFaqsResponse extends IGeneralResponse {
  data: Array<IFaq>
}

export interface IFaqFilter {
  page?: string
}

export interface IFaqsPayload extends IRequestPayload {
  filter?: IFaqFilter
}

export const fetchItems = async (
  payload: IFaqsPayload
): Promise<IFaqsResponse> => {
  const params = Object.assign(
    { limit: payload.limit, start: payload.start },
    nestedQueryFormatter('sorter', { direction: 'asc', field: 'position' }),
    nestedQueryFormatter('filter', payload.filter, false)
  )

  const response = await apiClient.get<IFaqsResponse>('/faqs', { params })
  return response.data
}

export const sendStatistic = async (
  id: string,
  page: string,
  hit: boolean,
  event: boolean
): Promise<IFaqResponse> => {
  const options = {
    id,
    page,
    hit,
    event
  }
  const response = await apiClient.post<IFaqResponse>(
    '/faqs/statistics',
    options
  )
  return response.data
}
